// src/redux/cargaMasivaSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosConfig";

export const resendInitialPasswords = createAsyncThunk(
  "cargaMasiva/resendInitialPasswords",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      // token desde store o fallback localStorage
      const token = auth?.token || localStorage.getItem("token");
      if (!token) return rejectWithValue("No hay token de autenticación.");

      // ⚠️ Deja que el backend aplique verificarToken + isAdmin
      const { data } = await api.post(
        "/auth/resend-initial-passwords",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data; // { total, ok, fail, errores: [...] }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Error al reenviar claves.";
      return rejectWithValue(msg);
    }
  }
);

export const uploadFile = createAsyncThunk(
  "cargaMasiva/uploadFile",
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("archivo", file);

      const { data } = await api.post("/api/carga-masiva", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    } catch (error) {
      const payload = error.response?.data || { message: "Error al cargar el archivo." };
      console.error("Error en la carga:", payload);
      return rejectWithValue(payload);
    }
  }
);

const cargaMasivaSlice = createSlice({
  name: "cargaMasiva",
  initialState: {
    loading: false,
    success: null,
    error: null,
    resultados: null,
    progress: 0,
    processingTime: "",
    resendLoading: false,
    resendResult: null,
    resendError: null,
  },
  reducers: {
    clearResendState(state) {
      state.resendLoading = false;
      state.resendResult = null;
      state.resendError = null;
    },
    clearMessages(state) {
      state.success = null;
      state.error = null;
      state.resultados = null;
      state.progress = 0;
      state.processingTime = "";
    },
    setProgress(state, action) {
      state.progress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Reenvío de claves
      .addCase(resendInitialPasswords.pending, (state) => {
        state.resendLoading = true;
        state.resendResult = null;
        state.resendError = null;
      })
      .addCase(resendInitialPasswords.fulfilled, (state, action) => {
        state.resendLoading = false;
        state.resendResult = action.payload;
      })
      .addCase(resendInitialPasswords.rejected, (state, action) => {
        state.resendLoading = false;
        state.resendError = action.payload || "Error al reenviar claves.";
      })

      // Carga masiva
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
        state.resultados = null;
        state.progress = 0;
        state.processingTime = "";
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message || "Carga masiva completada.";
        state.error = null;
        state.resultados = action.payload;
        state.progress = 100;
        state.processingTime = action.payload.tiempoProcesamiento || "";
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.payload?.error ||
          "Error al procesar el archivo";
        state.success = null;
        state.resultados = {
          ...action.payload,
          tiempoProcesamiento: action.payload?.tiempoProcesamiento || "",
        };
        state.progress = 0;
        state.processingTime = "";
      });
  },
});

export const { clearMessages, setProgress, clearResendState } = cargaMasivaSlice.actions;
export default cargaMasivaSlice.reducer;

// --- Selectores convenientes ---
export const selectCargaMasivaState = (state) => state.cargaMasiva;
export const selectResendLoading = (state) => state.cargaMasiva.resendLoading;
export const selectResendResult  = (state) => state.cargaMasiva.resendResult;
export const selectResendError   = (state) => state.cargaMasiva.resendError;
export const selectUploadLoading = (state) => state.cargaMasiva.loading;
export const selectUploadError   = (state) => state.cargaMasiva.error;
export const selectUploadSuccess = (state) => state.cargaMasiva.success;
export const selectResultados    = (state) => state.cargaMasiva.resultados;
export const selectProgress      = (state) => state.cargaMasiva.progress;
export const selectProcessingTime= (state) => state.cargaMasiva.processingTime;




